import { AppConfigInterface } from './app.config.interface';

export const devConfig: AppConfigInterface = {
  defaultAppName: 'debtorpanel',
  keycloakClientId: 'portal-frontend-local',
  defaultLocationId: 'pl',
  defaultCountryIsoCode: 'PL',
  apiURL: 'https://dev-portal.asseta.pl/',
  apiUrlInterceptor: /^(https:\/\/dev-portal\.asseta\.pl\/api)(\/.*)?$/i,
  locations: [
    {
      id: 'pl',
      label: 'PL',
      flagIsoCode: 'PL',
      hreflang: 'pl-PL',
      dedicatedUrl: 'https://debtorpanel.pl',
      hostMatchRegex: /\.pl$/,
      apiLanguageCode: 'pl',
      datePickerDateFormat: 'dd.mm.yyyy',
      defaultCountryCode: 'PL',
      logoUri: '/assets/img/logo.pl.webp',
      periodLogos: [
        {
          start: '12-06',
          end: '12-31',
          logo: '/assets/img/logo_xmas.webp',
        },
      ],
    },
    {
      id: 'en',
      label: 'US',
      flagIsoCode: 'US',
      hreflang: 'en-US',
      dedicatedUrl: 'https://debtorpanel.com',
      hostMatchRegex: /debtorpanel\.com$/,
      apiLanguageCode: 'en',
      datePickerDateFormat: 'mm/dd/yyyy',
      defaultCountryCode: 'US',
      periodLogos: [
        {
          start: '12-06',
          end: '12-31',
          logo: '/assets/img/logo_xmas.webp',
        },
      ],
    },
  ],
};